export const SIGNALR = {
  Platformorderfetcher: {
    EndPoint: 'platform-order-fetcher',
    Methods: {
      platformorderfetcher: 'platformorderfetcher',
      platformorderfetcherremoved: 'platformorderfetcherremoved',
      platformorderpickup: 'platformorderpickup',
      platformorderremovepickup: 'platformorderremovepickup',
    },
  },
  OrderReadbyBusinessunit: {
    EndPoint: 'order-read-by-business-unit',
    Methods: {
      addorderreadbybusinessunit: 'addorderreadbybusinessunit',
      deleteorderreadbybusinessunit: 'deleteorderreadbybusinessunit',
    },
  },
  OrderReadbyBusinessunitLabeless: {
    EndPoint: 'order-read-labeless-by-business-unit',
    Methods: {
      addorderreadlabelessbybusinessunit: 'addorderreadlabelessbybusinessunit',
      deleteorderreadlabelessbybusinessunit:
        'deleteorderreadlabelessbybusinessunit',
    },
  },
  OrderReadbyBusinessunitError: {
    EndPoint: 'order-drop-error',
    Methods: {
      droperror: 'droperror',
    },
  },
};
